<template>
  <div class="swiper-components">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item,index) in swiperSlides" :key="index">
        <img class="banner" :src="item.src">
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Swiper",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: true //可选选项，自动滑动
      },
      swiperSlides: [
        { src: require("../assets/images/banner1.jpg") },
        { src: require("../assets/images/banner2.jpg") },
        { src: require("../assets/images/banner3.jpg") }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   console.log('this is current swiper instance object', this.swiper)
  }
};
</script>

<style lang="scss">
@import "../../node_modules/swiper/dist/css/swiper.css";

.swiper-pagination-bullet {
  width: 52px;
  height: 9px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  opacity: 0.6;
}
.swiper-components {
  .banner {
    width: 100%;
    height: auto;
  }
  .swiper-pagination-bullet {
    width: 52px;
    height: 9px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    opacity: 0.6;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    width: 52px;
    height: 9px;
    background: rgba(254, 189, 0, 1);
    border-radius: 5px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 100px;
  }
}
</style>